// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-chevron.up {\n  transform: rotate(180deg);\n}\n.icon-chevron.down {\n  transform: rotate(0deg);\n}\n.icon-chevron.left {\n  transform: rotate(90deg);\n}\n.icon-chevron.right {\n  transform: rotate(270deg);\n}\n", ""]);
// Exports
module.exports = exports;
